<template>
    <div class="page-wrapper">
      <TrfGlobalLoader v-if="isFormLoading" v-e2e="'template-loader'" type="fixed" />
      <div class="container is-flex is-flex-direction-column is-align-items-center">
        <template v-for="(campoEmpresa, index) in formData.camposEmpresa" :key="campoEmpresa.id? campoEmpresa.id : campoEmpresa.uuid? campoEmpresa.uuid : index">
            <div class="box-campo is-relative" tabindex="-1">
              <p v-if="campoEmpresa.tituloHtml" class="is-size-6 mb-2" v-html="campoEmpresa.tituloHtml"></p>
              <TrfCampoPreenchivel :pCampo="campoEmpresa" @elegalize-iniciar-formulario-socio="doAbrirModalCadastroSocio"></TrfCampoPreenchivel>
            </div>
        </template>
      </div>
      <TrfSimpleModal v-if="modalVisualizarSocio.isActive"
        titulo="Cadastro de Sócio"
        :isAtivo="modalVisualizarSocio.isActive"
        @close="doFecharModalCadastroSocio"
      >
        <div class="is-flex is-flex-direction-column is-align-items-center">
          <template v-for="(camposSocio, index) in formData.camposSocio" :key="camposSocio.id? camposSocio.id : camposSocio.uuid? camposSocio.uuid : index">
              <div class="box-campo-socio is-relative" tabindex="-1">
                <p v-if="camposSocio.tituloHtml" class="is-size-6 mb-2" v-html="camposSocio.tituloHtml"></p>
                <TrfCampoPreenchivel :pCampo="camposSocio"></TrfCampoPreenchivel>
              </div>
          </template>
        </div>
        
        <template v-slot:slot-footer>
          <div>
            <button
              :class="{ 'button is-primary': true }"
              disabled
              inert
            >Cadastrar</button>
            <button
              class="button"
              @click="doFecharModalCadastroSocio"
            >Cancelar</button>
          </div>
        </template>
      </TrfSimpleModal>
    </div>
  </template>
  
  <script>
  import { defineAsyncComponent } from 'vue';
  import { routerUtils } from '../../util/router.utils';
  import Formulario from '../../model/formulario.model.js';
  
  export default {
    name: "TrfVisualizarForm",
    components: {
      TrfGlobalLoader: defineAsyncComponent(() => import('../GlobalLoader/index.vue')),
      TrfCampoPreenchivel: defineAsyncComponent(() => import('./components/CampoPreenchivel.vue')),
      TrfSimpleModal: defineAsyncComponent(() => import('../Modal/TrfSimpleModal.vue'))
    },
    async beforeRouteEnter(to, from, next) {
      next((vm) => vm.$data.isDefaultForm = true);
    },
    async beforeRouteUpdate(to) {
      if (!!id) {
        this.carregarDadosPorId(id);
      }
    },
    props: {
        pIsVisualizarSocio: {
          type: Boolean,
          default: false
        },
        pFormData: {
            type: Object,
            default: new Formulario()
        }
    },
    data() {
      return {
        isFormLoading: false,
        estilosPadrao: '',
        formData: this.pFormData,
        modalVisualizarSocio: {
          isActive: false
        }
      }
    },
    computed: {

    },
    watch: {
      pFormData: {
        immediate: true,
        handler(novo) {
          this.formData = novo
        },
        deep: true
      }
    },
    methods: {
      doAbrirModalCadastroSocio() {
        this.modalVisualizarSocio.isActive = true;
      },
      doFecharModalCadastroSocio() {
        this.modalVisualizarSocio.isActive = false;
      },
      doFechar() {
        routerUtils._carregarNovaRota("/formularios/")
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
    @import '../../assets/sass/variables.scss';
    .page-wrapper {
      width:100%;
    }
    .container {
      box-sizing:border-box;
      padding-right:4rem;
    }
    .box-campo {
      border-top:.75rem solid var(--primaryColor, #a82339);
      border-left:1rem solid var(--primaryColor, #a82339);
      border-radius:8px;
      padding:2em;
      width:100%;
      max-width:744px;
      box-sizing: border-box;
      box-shadow:2px 2px 2px #70757a66;
      transition: border 0.35s ease 0s;
      margin-bottom:2.25rem;
    }
    .box-campo-socio {
      width:100%;
      max-width:744px;
      margin-bottom:2.25rem;
    }
    .box-campo, .box-campo-socio {
      word-break: break-word;
      overflow-wrap: anywhere;
      white-space: normal;
    }
  </style>